import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import Radio from "components/common/Radio";
import { useMarkSenderAsSpam } from "services/email";

interface Props {
  open: boolean;
  fromAddress: string;
  emailRef: string;
  onClose: () => void;
  onSpamMarked: () => void;
}

const MarkSpamDialog = ({
  open,
  fromAddress,
  emailRef,
  onClose,
  onSpamMarked,
}: Props) => {
  const [blockDomain, setBlockDomain] = useState(false);
  const { request, loading } = useMarkSenderAsSpam();

  const domain = fromAddress.includes("@") ? fromAddress.split("@")[1] : null;

  const handleConfirm = async () => {
    await request({ emailRef, blockDomain });
    onSpamMarked();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Block sender</DialogTitle>
      <DialogContent>
        <Typography
          variant="body"
          sx={{ color: "#6B6E7B", display: "block", mb: 2 }}
        >
          Future emails from this sender won't appear in your inbox.
        </Typography>
        <FormControl>
          <RadioGroup
            value={blockDomain ? "domain" : "email"}
            onChange={(e) => setBlockDomain(e.target.value === "domain")}
          >
            <FormControlLabel
              value="email"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="bodyHeavy">{fromAddress}</Typography>
                  <Typography
                    variant="bodySmall"
                    sx={{ color: "#6B6E7B", display: "block" }}
                  >
                    Block this address only
                  </Typography>
                </Box>
              }
            />
            {domain && (
              <FormControlLabel
                value="domain"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="bodyHeavy">@{domain}</Typography>
                    <Typography
                      variant="bodySmall"
                      sx={{ color: "#6B6E7B", display: "block" }}
                    >
                      Block all senders from this domain
                    </Typography>
                  </Box>
                }
              />
            )}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button variant="text" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
          sx={{ background: "#C14743", "&:hover": { background: "#a33a37" } }}
        >
          Block sender
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkSpamDialog;
